import { QueryClient } from "@tanstack/react-query";

import { defaultRetry } from "@tsmono/react";

/**
 * Shared react-query client singleton. Used both by the `<QueryClientProvider>`
 * in App.tsx and by non-React code (the replication sync) that writes into the
 * cache via `queryClient.setQueryData`. Mirrors the singleton store created in
 * main.tsx.
 */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: defaultRetry } },
});
